import { render, staticRenderFns } from "./MiniMap.vue?vue&type=template&id=4dbce4e4&"
import script from "./MiniMap.vue?vue&type=script&lang=js&"
export * from "./MiniMap.vue?vue&type=script&lang=js&"
import style0 from "./MiniMap.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports